const setExploreList = data => ({
  type: "SET_Explore_LIST",
  data
});

export const mutation = {
  setExploreList
};
